import AbstractOperatorApplicationListener
    from "~/operatorApplication/ts/service/comet/AbstractOperatorApplicationListener";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";

export default class RemoveClientFromBuddyList extends AbstractOperatorApplicationListener {
    public getAction(): string {
        return "removeClientFromBuddyList";
    }

    public receive(payload: CometOperatorApplication.RemoveClientFromBuddyListCometMessageOpenApiModel): void {
        ClientUserdataStore.unsetClientLastActivityTimestamp(payload.username);
        OperatorAccountStore.removeClientFromBuddyList(payload.username);
    }

}